import { useStripe, useElements, PaymentElement } from '@stripe/react-stripe-js';
// import styles from './SubscribeModal.module.css';
import {
  makeStyles
} from '@material-ui/core';

const INTERVAL_LABEL = { month: 'mo', year: 'yr' };

/**
 * CheckoutForm
 * Must live inside an <Elements> provider.
 *
 * Props:
 *   plan      { name, amount, interval }
 *   step      string  (idle | setup | confirming | subscribing | error)
 *   error     string | null
 *   onConfirm (stripe, elements) => void
 */
const useStyles = makeStyles((theme) => ({
  paypalBtnBox: {
    position: 'relative',
    display: 'block',
  },
  paypalHideBtn: {
    right: 0,
    cursor: 'pointer',
    paddingLeft: '6px',
    paddingRight: '6px',
    paddingTop: '4px',
    paddingBottom: '10px',
    marginLeft: '2px',
  },
}));

export default function StripeCheckoutForm(props) {
  const { plan, step, error, onConfirm } = props;
  const styles = useStyles();

  const stripe = useStripe();
  const elements = useElements();

  const isLoading = step === 'confirming' || step === 'subscribing';

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!stripe || !elements || isLoading) return;
    onConfirm(stripe, elements);
  };

  const label = step === 'subscribing' ? 'Creating subscription…'
    : step === 'confirming' ? 'Confirming card…'
      : `Subscribe — $${plan.amount} / ${INTERVAL_LABEL[plan.interval] ?? plan.interval}`;

  return (
    <form onSubmit={handleSubmit} noValidate>
      {/* Stripe's unified payment UI (card, Apple Pay, Google Pay, Link…) */}
      <PaymentElement
        options={{
          layout: 'tabs',
          // Collect billing details if you need them
          fields: { billingDetails: { name: 'auto', email: 'auto' } },
        }}
      />

      {/* Order summary */}
      <div className={styles.summary}>
        <div className={styles.summaryRow}>
          <span>{plan.name}</span>
          <span>${plan.amount} / {plan.interval}</span>
        </div>
        <div className={styles.summaryRow}>
          <span style={{ color: '#888' }}>Tax</span>
          <span style={{ color: '#888' }}>$0.00</span>
        </div>
        <div className={`${styles.summaryRow} ${styles.summaryTotal}`}>
          <span>Due today</span>
          <span>${plan.amount}</span>
        </div>
      </div>

      {/* Error */}
      {error && (
        <p className={styles.errorMsg} role="alert">
          {error}
        </p>
      )}

      {/* Submit */}
      <button
        type="submit"
        disabled={!stripe || isLoading}
        className={styles.submitBtn}
      >
        {isLoading && <Spinner />}
        {label}
      </button>

      <p className={styles.secureNote}>
        🔒 Secured by Stripe · Cancel anytime
      </p>
    </form>
  );
}

function Spinner() {
  return (
    <span
      style={{
        display: 'inline-block',
        width: 14,
        height: 14,
        border: '2px solid rgba(255,255,255,0.4)',
        borderTopColor: '#fff',
        borderRadius: '50%',
        animation: 'spin 0.7s linear infinite',
        marginRight: 8,
      }}
    />
  );
}
